export default "__VITE_ASSET__DpiE2aEL__"